module.exports = __webpack_public_path__ + "static/img/case-zlj-page-bg-08.1b13286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zlj/case-zlj-page-bg-08.jpg
// module id = jNT+
// module chunks = 1